import HttpFactory from '@/mixins/http.factory';
export default {
	name:'index',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			message:null
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
		},
		connectZendesk() {
			
		}
	},
	components:{}
}

